import {Flex} from "antd";
import classes from "../Header/header.module.css";
import {clrs} from "../../../constants/colors";
import {Link} from "react-router-dom";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import React from "react";

export const Header = () => {
    return (
        <Flex className={classes.main} style={{position: "relative"}} align={"center"} justify={"center"}>
            <div style={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                height: 90,
                backgroundColor: clrs.whiter
            }}></div>
            <Flex className={classes.inner_main} align={"center"} justify={"flex-start"} gap={75}>
                <Link to={'/'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.main'}/></Link>
                <Link to={'/monitoring'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.monitoring'}/></Link>
                <Link to={'/about'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.aboutProject'}/></Link>
                {/*<Link className={classes.hover_text2}*/}
                {/*      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage*/}
                {/*    id={'homePage.systemTradeEmission'}/></Link>*/}
            </Flex>

        </Flex>
    );
};